import { type SaleAssetBusEntity } from '~/apiClient';
import type { SaleItemEntity } from '~/types/sale.type';

export default (sale: SaleItemEntity): SaleAssetBusEntity[] => sale.assets.toSorted(a => (a.id === sale.mainAssetId ? -1 : 0));
